import React from 'react'
import isEqual from 'lodash/isEqual'
import { Button } from 'transfix-ui/components/Button'
import Box from 'transfix-ui/core/Box'
import { brandColors } from 'transfix-ui/theme/colors'
import { TAutobiddersFiltersSchema } from 'apps/spot-quote-control-panel/schema/AutobiddersFiltersSchema'
import { appliedFilterNames } from '../../utils/autobidders'

export interface IAppliedFiltersProps {
  bidderFilters: TAutobiddersFiltersSchema
  defaultFilters: TAutobiddersFiltersSchema
  setFilters: React.Dispatch<React.SetStateAction<TAutobiddersFiltersSchema>>
}

export const AppliedFilters = ({
  bidderFilters,
  defaultFilters,
  setFilters,
}: IAppliedFiltersProps) => {
  const onClearFilters = () => {
    setFilters(defaultFilters)
  }

  if (isEqual(bidderFilters, defaultFilters)) {
    return null
  }

  return (
    <Box color={brandColors.gray3} ml={1}>
      <span>{appliedFilterNames(bidderFilters)}</span>
      <Button color='tertiary' onClick={onClearFilters}>
        Clear All
      </Button>
    </Box>
  )
}
